<template>
  <div class="table-container">
    <div class="table-content-box">
      <div :class="showPagination?'table-box':'table-box1'">
        <el-table
          ref="table"
          :height="height"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255,0.8)"
          :data="data"
          :header-cell-style="tableHeaderColor"
          :row-style="showRow"
          :show-header="showHeader"
          :row-key="rowKey"
          :tree-props="treeProps"
          style="width: 100%"
          @expand-change="expandChange"
          @selection-change="handleSelectionChange"
          @select="handleSelect"
          @select-all="handleSelectAll"
          @sort-change="sortChangeFunction"
          @row-click="handdle"
          highlight-current-row>
          <el-table-column
            v-if="!expand && selection"
            type="selection"
            key="11"
            align="center"
            width="55"
            :selectable="selectable"
            :reserve-selection="isReserveSelection" />
          <el-table-column
            v-if="!expand && showIndex"
            label="序号"
            align="center"
            type="index"
            :width="indexWidth"
            :index="indexMethod"
            :fixed="indexFixed" />
          <el-table-column v-if="expand" type="expand">
            <template slot-scope="props">
              <slot name="expand" :props="props"></slot>
            </template>
          </el-table-column>
          <template v-for="(item, index) in column">
            <template v-if="item.show">
              <el-table-column
                v-if="item.label == '操作' && !item.scopeStatus"
                :key="index"
                :label="item.label"
                :width="item.width ? item.width : 'auto'"
                :align="item.align ? item.align : 'left'"
                :min-width="item.minWidth">
                <template slot-scope="scope">
                  <template v-for="(button, bIdx) in tableButtons">
                    <el-button
                      :key="button.label"
                      :class="
                        button.disabled
                          ? !button.disabled(scope.row, scope.$index) &&
                            button.color
                          : button.color
                      "
                      type="text"
                      :size="button.size"
                      v-bind="button"
                      :disabled="
                        button.disabled
                          ? button.disabled(scope.row, scope.$index)
                          : false
                      "
                      @click.native.prevent="onButtonClick(button, scope)">
                      {{
                        button.labelFunction
                          ? button.labelFunction(scope.row, scope.$index)
                          : button.label
                      }}
                    </el-button>
                    <div v-show="bIdx != tableButtons.length - 1" :key="bIdx" class="verticalLine"></div>
                  </template>
                </template>
              </el-table-column>
              <!--              :show-overflow-tooltip="-->
              <!--              item.showOverflowTooltip !== undefined &&-->
              <!--              item.showOverflowTooltip-->
              <!--              "-->
              <el-table-column
                v-else
                :key="index"
                :fixed="item.fixed"
                :width="item.width ? item.width : 'auto'"
                :min-width="item.minWidth"
                :prop="item.prop"
                show-overflow-tooltip
                :sortable="item.sortable !== undefined && item.sortable"
                :align="item.align ? item.align : 'left'"
                :label="item.label"
                :render-header="item.icon ? renderFun : defaultRenderFun">
                <template slot-scope="scope">
                  <span :class="item.primaryProperty || ''" @click="handleContentClick(scope.row, item)">
                    <slot
                      v-if="item.scopeStatus"
                      :name="item.prop"
                      :row="scope.row"
                      :number="item.index"
                      :index="scope.$index" />
                    <span v-else-if="item.filterType === 'select'">
                      <span>
                        {{
                        selectFilter(
                          item.options,
                          scope.row[item.prop],
                          item.optionType
                        )
                        }}
                      </span>
                    </span>
                    <span v-else-if="item.filterType === 'datetime'">
                      {{
                        $dateFormatter(
                          scope.row[item.prop],
                          item.filterTypeFormatter || "YYYY-MM-DD HH:mm"
                        )
                      }}
                    </span>

                    <template v-else>
                      <template v-if="item.prepend">{{ item.prepend }}{{ scope.row[item.prop] }}</template>
                      <template v-else-if="item.suffix">{{ scope.row[item.prop] }}{{ item.suffix }}</template>
                      <template v-else>
                        {{
                          scope.row[item.prop]
                            ? scope.row[item.prop]
                            : scope.row[item.prop] === 0
                            ? 0
                            : "-"
                        }}
                      </template>
                    </template>
                  </span>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </div>
    </div>
    <!--    v-if="total > 0 && showPagination"-->
    <div :class="isScroll ? 'pagination-box' : 'pagination-box1'" v-if="showPagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        background
        :layout="layout"
        :total="total" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TableContainer",
  components: {},
  props: {
    tableHeader: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // no-data-text
    noDataText: {
      type: String,
      default: "暂无数据",
    },
    // height: {
    //   type: String,
    //   default: "100%",
    // },
    layout: {
      type: String,
      default: "total, prev, pager, next, jumper, sizes",
    },
    // table的数据
    data: {
      type: Array,
      default: () => [],
    },
    // 每一列
    column: {
      type: Array,
      default: () => [],
    },
    // table的loading
    loading: {
      type: Boolean,
      default: false,
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
    showSearchBox: {
      type: Boolean,
      default: true,
    },
    // 是否显示表格头部
    showHeader: {
      type: Boolean,
      default: true,
    },
    // //表头设置icon
    // icon: {
    //   type: Boolean,
    //   default: true
    // },
    // //表头提示性文字
    // tipText: {
    //   type: String,
    //   default: ""
    // },
    // 是否展示序号
    showIndex: {
      type: Boolean,
      default: false,
    },
    //序号固定
    indexFixed: {
      type: [String, Boolean],
      default: false,
    },
    // 序号的宽度
    indexWidth: {
      type: String,
      default: "65",
    },
    // 是否多选
    selection: {
      type: Boolean,
      default: false,
    },
    // 操作按钮
    tableButtons: {
      type: Array,
      default: () => [],
    },
    // 是否展示分页组件
    pagination: {
      type: Boolean,
      default: true,
    },
    // 分页的页数
    page: {
      type: Number,
      default: 1,
    },
    // 每一页的数量
    size: {
      type: Number,
      default: 10,
    },
    // 分页总数量
    total: {
      required: false,
      type: Number,
      default: 0,
    },
    // 是否展示分页的说明
    showDescribe: {
      type: Boolean,
      default: false,
    },
    // 说明文字
    totalDescribe: {
      type: String,
      default: "",
    },
    // 分页组件的定位
    position: {
      type: String,
      default: "right",
    },
    // 分页组件的背景色
    background: {
      type: Boolean,
      default: true,
    },
    // 分页组件的大小
    small: {
      type: Boolean,
      default() {
        return false;
      },
    },
    // 分页组件的页数限制 [5-21 奇数]
    pagerCount: {
      type: Number,
      default() {
        return 5;
      },
    },
    // 是否切换分页后保留之前选中数据[true](需配合row-key使用) 默认false
    isReserveSelection: {
      type: Boolean,
      default: false,
    },
    // 表格的每一行的key
    rowKey: {
      type: String || Function,
      default: "",
    },
    // 设置是否展开
    expand: {
      type: Boolean,
      default: false,
    },
    // 是否全局滚动表格
    isScroll: {
      type: Boolean,
      default: true,
    },
    // 设置selection是否勾选
    selectable: {
      type: Function,
      default: () => {
        return true;
      },
    },
    // 每页显示个数选择器的选项设置
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40, 50, 100],
    },
    // 树形表格配置
    treeProps: {
      type: Object,
      default: () => {
        return {
          children: "children",
          hasChildren: "hasChildren",
        };
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    height: function() {
      return this.showPagination?'calc(100% - 0.5rem)':'100%'
    },
    tableHeaderColor() {
      return {
        background: "#F0F5FF",
        color: "#000000",
        fontFamily: "pm",
        fontSize: "0.14rem",
      };
    },
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      },
    },
    pageSize: {
      get() {
        return this.size;
      },
      set(val) {
        this.$emit("update:size", val);
      },
    },
  },

  created() {},
  mounted() {},
  methods: {
    /**
     * @description 多选
     * @author xiaohongjian
     * @param 参数名 参数描述 {*}
     * @return *
     */
    handleSelectionChange(val) {
      this.$emit("selectionChange", val);
    },
    handleSelectAll(val) {
      this.$emit("selectionAll", val);
    },
    // 单个勾选
    handleSelect(val, row) {
      this.$emit("handleSelect", { val: val, row: row });
    },
    /**
     * @description 清空多选
     * @author xiaohongjian
     * @return *
     */
    clearSelection() {
      this.$refs.table.clearSelection();
      this.$emit("selectionChange", []);
    },
    /**
     * @description 序号累加
     * @author wangyuanbo
     * @return *
     */
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    //选中当前行
    handdle(row, event, column) {
      // // console.log(row, event, column);
      // this.$refs.table.handdle();
      this.$emit("handdle", { row: row, event: event, column: column });
    },
    /**
     * @description 后端排序
     * @author xiaohongjian
     * @param order 排序方式 {"ascending" | 'descending'}
     * @param prop 排序的字段名
     * @return *
     */
    sortChangeFunction(column) {
      this.$emit("sortChange", column);
    },
    handleSizeChange(val) {
      this.$emit("pagination", { page: 1, size: val });
    },
    handleCurrentChange(val) {
      this.$emit("pagination", { page: val, size: this.pageSize });
    },
    showRow({ row, rowIndex }) {
      let styleJson = {};
      if (rowIndex % 2 === 0) {
        styleJson = {
          height: "46px",
          background: "#fff",
        };
      } else {
        styleJson = {
          height: "46px",
          background: "rgba(240,245,255,0.4)",
          border: "none",
        };
      }
      // 返回对象
      return styleJson;
    },
    clearSelect() {
      this.$refs.table.clearSelection();
    },
    // 选中回显
    toggleSelection(rows) {
      // console.log("rowsrows", rows);
      this.$nextTick(() => {
        if (rows && rows.length > 0) {
          rows.forEach((row) => {
            // console.log("arr", row);
            this.$refs.table.toggleRowSelection(row, true);
          });
        } else {
          this.$refs.table.clearSelection();
        }
      });
    },
    /**
     * @description 选择过滤器
     */
    selectFilter(options, value, optionType) {
      let option;
      if (optionType === "custom") {
        let item = options.filter((option) => option.item_number === value)[0];
        option = item.item_value;
      } else if (optionType === "gb") {
        let item = options.filter((option) => option.item_code === value)[0];
        option = item.item_name;
      } else {
        let item = options.filter((option) => option.value === value)[0];
        option = item.label;
      }
      return option;
    },
    /**
     * @description 按钮被点击
     */
    onButtonClick(button, scope) {
      if (button && button.onclick) {
        button.onclick(scope);
      }
    },
    /**
     * @description 内容被点击时
     */
    handleContentClick(row, item) {
      // 如果是主要字段，才会响应
      if (item.primaryProperty) {
        this.$emit("onPrimaryPropertyClick", { row, prop: item.prop });
      }
    },
    /**
     * @description 展开项触发事件
     * @author xiaohongjian
     */
    expandChange(row) {
      this.$emit("expandChange", row);
    },
    renderFun(h, { column, $index }) {
      return [
        column.label + " ",
        h(
          "el-tooltip",
          {
            props: {
              width: "200",
              trigger: "hover",
              content: column.showOverflowTooltip, // 鼠标悬停时要展示的文字提示
              placement: "top", // 悬停内容展示的位置
            },
          },
          [h("span", { class: { "el-icon-warning-outline": true } })] // 图标
        ),
      ];
    },
    defaultRenderFun(h, { column, $index }) {
      return [column.label];
    },
  },
};
</script>
<style lang="scss">
.table-content-box {
  width: 100%;
  height: 100%;
  .el-table td,
  .el-table th {
    color: #1f2329;
    font-size: 0.14rem;
    font-weight: 500;
  }
  .el-checkbox__inner {
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 0.03rem;
    border: 1px solid #cbd5e0;
  }
  .el-checkbox__inner::after {
    height: 0.12rem;
    left: 0.08rem;
  }
}
.el-table__empty-text {
  padding-top: 0.5rem;
}
//.el-table__header-wrapper {
//  position: absolute;
//  z-index: 10;
//  top: 0;
//}
.el-table__fixed-right{
  background-color: #ffffff;
  //z-index: 10;
  //bottom: 0;
}
.el-table__fixed-right::before, .el-table__fixed::before{
  display: none;
}
.pagination-box {
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    width: auto;
    height: 0.32rem;
    min-width: 0.32rem;
    border: 0.01rem solid rgba(191, 191, 191, 0.5);
    color: #595959;
    line-height: 0.32rem;
  }
  .el-pagination.is-background .btn-next.disabled,
  .el-pagination.is-background .btn-next:disabled,
  .el-pagination.is-background .btn-prev.disabled,
  .el-pagination.is-background .btn-prev:disabled,
  .el-pagination.is-background .el-pager li.disabled {
    background-color: #ffffff;
  }
  //.el-pagination.is-background .el-pager li:not(.disabled).active {
  //  background-color: #ffffff;
  //  border-color: #3370ff;
  //  color: #3370ff;
  //}
  .el-pagination {
    padding: 0;
  }
  .el-pagination__sizes {
    margin-right: 0;
  }
  .el-pagination .el-select .el-input {
    margin-right: 0;
  }
}
</style>
<style lang="scss" scoped>
.table-container {
  height: 100%;
  position: relative;
  //margin-bottom: 0.68rem;

  .table-box {
    background-color: #ffffff;
    padding: 0.1rem;
    box-sizing: border-box;
    height: calc(100% - 0.5rem);
    display: flex;
    flex-direction: column;
    border-radius: 0.04rem;
    overflow: hidden;
  }
  .table-box1 {
    background-color: #ffffff;
    padding: 0.1rem;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 0.04rem;
    overflow: hidden;
  }
  //.flex-table {
  //  width: 100%;
  //  height: 100%;
  //  overflow: hidden;
  //  //display: flex;
  //  //flex-direction: column;
  //  position: relative;
  //}
  //::v-deep .el-table {
  //  display: flex;
  //  flex-direction: column;
  //}
  //::v-deep .el-table__body-wrapper {
  //  height: 100%;
  //  overflow-y: auto;
  //  padding-top: 0.44rem;
  //  //padding-bottom: 0.48rem;
  //}
  //.table-search-box {
  //  flex: 1;
  //  overflow-y: auto;
  //  padding: 0.2rem 0.22rem 0.25rem;
  //  //margin-top: 0.25rem;
  //  box-sizing: border-box;
  //}
  .pagination-box {
    flex-shrink: 0;
    display: flex;
    justify-content: right;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    position: sticky;
    bottom: -0.2rem;
    z-index: 10;

    .pagination-box-left {
      display: flex;
      align-items: center;
      .pagination-box-text {
        color: #718096;
        font-size: 0.14rem;
        padding-right: 0.02rem;
      }
    }
  }
  .pagination-box1 {
    flex-shrink: 0;
    display: flex;
    justify-content: right;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    z-index: 10;
    width: 100%;

    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #ffffff;
    .pagination-box-left {
      display: flex;
      align-items: center;
      .pagination-box-text {
        color: #718096;
        font-size: 0.14rem;
        padding-right: 0.02rem;
      }
    }
  }
}
</style>
